import { Category, Company, Product, Tax } from '../../../../models';

export const ACTIONS = {
  TITLE: 'TITLE',
  PRIORITY: 'PRIORITY',
  RATING: 'RATING',
  POINTS: 'POINTS',
  REVIEWS: 'REVIEWS',
  COMMENTS: 'COMMENTS',
  OPTIONS: 'OPTIONS',
  VARIANTS: 'VARIANTS',
  CATEGORY: 'CATEGORY',
  TAXES: 'TAXES',
  DESCRIPTION: 'DESCRIPTION',
  STATUS: 'STATUS',
  COMPANY: 'COMPANY',
  DEFAULT: 'DEFAULT',
} as const;

export type ACTIONS_TYPE =
  | { type: 'TITLE'; payload: string }
  | { type: 'PRIORITY'; payload: number }
  | { type: 'DESCRIPTION'; payload: string }
  | { type: 'RATING'; payload: number }
  | { type: 'POINTS'; payload: number }
  | { type: 'REVIEWS'; payload: number }
  | { type: 'CATEGORY'; payload: Category | string }
  | { type: 'TAXES'; payload: Tax[] | string[] }
  | { type: 'COMPANY'; payload: Company | string }
  | { type: 'DEFAULT'; payload: Partial<Product> };

export function reducer(
  state: Partial<Product>,
  action: ACTIONS_TYPE
): Partial<Product> {
  switch (action.type) {
    case ACTIONS.TITLE:
      return { ...state, title: action.payload };
    case ACTIONS.DESCRIPTION:
      return { ...state, description: action.payload };
    case ACTIONS.PRIORITY:
      return { ...state, priority: action.payload };
    case ACTIONS.RATING:
      return { ...state, rating: action.payload };
    case ACTIONS.POINTS:
      return { ...state, points: action.payload };
    case ACTIONS.REVIEWS:
      return { ...state, reviews: action.payload };
    case ACTIONS.CATEGORY:
      return { ...state, category: action.payload };
    case ACTIONS.COMPANY:
      return { ...state, company: action.payload as string };
    case ACTIONS.TAXES:
      return { ...state, taxes: action.payload };
    case ACTIONS.DEFAULT:
      return { ...state, ...(action?.payload ?? {}) };
    default:
      return { ...state };
  }
}
